import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  styles: {
    global: {
      body: {
        backgroundColor: "gray.100",
        color: "gray.800",
      },
    },
  },
  components: {
    FormLabel: {
      baseStyle: {
        color: "gray.600",
        fontSize: "sm",
      },
    },
  },
});
export default theme;
